// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"86b3cbd7","453":"6f10c186","455":"18fea946"}[chunkId] + ".chunk.js";
};